/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit Add.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import * as fromData from 'Data/ViewsData.js'
import AddAction from './AddAction/view.js'
import CancelAction from './CancelAction/view.js'
import Companies from './Companies/logic.js'
import Email from './Email/logic.js'
import ExistingUsers from './ExistingUsers/logic.js'
import FirstName from './FirstName/logic.js'
import GiveAccessAsUser from './GiveAccessAsUser/view.js'
import Info from 'DesignSystem/Info/view.js'
import IsAcceptingNewPatients from './IsAcceptingNewPatients/view.js'
import LastName from './LastName/logic.js'
import Licenses from './Licenses/logic.js'
import ModalContent from 'DesignSystem/ModalContent/view.js'
import ModalHeader from 'DesignSystem/ModalHeader/view.js'
import PhoneNumber from './PhoneNumber/logic.js'
import ProviderLocations from './ProviderLocations/logic.js'
import React from 'react'
import SubTitle from 'DesignSystem/SubTitle/view.js'
import { css } from "emotion"
Companies.displayName = 'CompaniesLogic'
Email.displayName = 'EmailLogic'
ExistingUsers.displayName = 'ExistingUsersLogic'
FirstName.displayName = 'FirstNameLogic'
LastName.displayName = 'LastNameLogic'
Licenses.displayName = 'LicensesLogic'
PhoneNumber.displayName = 'PhoneNumberLogic'
ProviderLocations.displayName = 'ProviderLocationsLogic'

let styles = {}
styles.Horizontal = css({label: 'Horizontal',
  flexDirection: "row",
marginTop: 16})
styles.Horizontal1 = css({label: 'Horizontal1',
  flexDirection: "row",
marginTop: 16,
marginBottom: 50})
styles.Horizontal2 = css({label: 'Horizontal2',
  flexDirection: "row",
marginTop: 30,
  opacity: 'var(--opacity)'})
styles.Horizontal3 = css({label: 'Horizontal3',
  flexDirection: "row",
marginTop: 30,
  opacity: 'var(--opacity)'})
styles.Vertical = css({label: 'Vertical',
  marginTop: 30})
styles.Vertical1 = css({label: 'Vertical1',
  marginTop: 16})
styles.Vertical2 = css({label: 'Vertical2',
  marginTop: 16,
marginBottom: 50})

export default function Add({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  value,
viewPath= "/App/MyAccount/Content/Profile/Content/MyProfessionals/Item/Content/Add"
}) {
    
    
    
    
    let data = fromData.useData({ viewPath, path: 'professional.useExistingUser', 
context: 'professional',
})
    

  return (<React.Fragment
>
<ModalHeader
 data-testid="Add.ModalHeader"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyProfessionals/Item/Content/Add"
viewPath={`${viewPath}/ModalHeader`}
 text="Add a professional"
>
{childProps => (
<React.Fragment>
<AddAction
{...childProps}
 data-testid="Add.AddAction"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyProfessionals/Item/Content/Add"
viewPath={`${viewPath}/AddAction`}
/>
<CancelAction
{...childProps}
 data-testid="Add.CancelAction"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyProfessionals/Item/Content/Add"
viewPath={`${viewPath}/CancelAction`}
/>
</React.Fragment>
)}
</ModalHeader>
<ModalContent
 data-testid="Add.ModalContent"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyProfessionals/Item/Content/Add"
viewPath={`${viewPath}/ModalContent`}
>
{childProps => (
<React.Fragment>
<SubTitle
{...childProps}
 data-testid="Add.SubTitle"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyProfessionals/Item/Content/Add"
viewPath={`${viewPath}/SubTitle`}
 text="Add to the following companies"
/>
<div
 data-testid="Add.Horizontal"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyProfessionals/Item/Content/Add"
 className={`views-block ${styles.Horizontal}`}
>
<Companies
 data-testid="Add.Companies"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyProfessionals/Item/Content/Add"
viewPath={`${viewPath}/Companies`}
/>
</div>
<SubTitle
{...childProps}
 data-testid="Add.SubTitle:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyProfessionals/Item/Content/Add"
viewPath={`${viewPath}/SubTitle`}
 marginTop={50}
 text="Select an existing non-professional"
/>
<div
 data-testid="Add.Horizontal:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyProfessionals/Item/Content/Add"
 className={`views-block ${styles.Horizontal1}`}
>
<ExistingUsers
 data-testid="Add.ExistingUsers"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyProfessionals/Item/Content/Add"
viewPath={`${viewPath}/ExistingUsers`}
/>
</div>
<SubTitle
{...childProps}
 data-testid="Add.SubTitle:2"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyProfessionals/Item/Content/Add"
viewPath={`${viewPath}/SubTitle`}
 text="Or create new professional"
 opacity={data.value ? 0.5 : 1}
/>
<div
 data-testid="Add.Horizontal:2"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyProfessionals/Item/Content/Add"
 style={{'--opacity': data.value ? 0.5 : 1}}
 className={`views-block ${styles.Horizontal2}`}
>
<FirstName
 data-testid="Add.FirstName"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyProfessionals/Item/Content/Add"
viewPath={`${viewPath}/FirstName`}
/>
<LastName
 data-testid="Add.LastName"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyProfessionals/Item/Content/Add"
viewPath={`${viewPath}/LastName`}
/>
</div>
<div
 data-testid="Add.Horizontal:3"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyProfessionals/Item/Content/Add"
 style={{'--opacity': data.value ? 0.5 : 1}}
 className={`views-block ${styles.Horizontal3}`}
>
<PhoneNumber
 data-testid="Add.PhoneNumber"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyProfessionals/Item/Content/Add"
viewPath={`${viewPath}/PhoneNumber`}
/>
<Email
 data-testid="Add.Email"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyProfessionals/Item/Content/Add"
viewPath={`${viewPath}/Email`}
/>
</div>
<Info
{...childProps}
 data-testid="Add.Info"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyProfessionals/Item/Content/Add"
viewPath={`${viewPath}/Info`}
 marginTop={12}
 marginLeft={8}
 fontSize={12}
 text="All users have one unique profile, so the mobile number is required in case the user becomes a benefits member."
/>
<div
 data-testid="Add.Vertical"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyProfessionals/Item/Content/Add"
 className={`views-block ${styles.Vertical}`}
>
<IsAcceptingNewPatients
 data-testid="Add.IsAcceptingNewPatients"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyProfessionals/Item/Content/Add"
viewPath={`${viewPath}/IsAcceptingNewPatients`}
/>
<GiveAccessAsUser
 data-testid="Add.GiveAccessAsUser"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyProfessionals/Item/Content/Add"
viewPath={`${viewPath}/GiveAccessAsUser`}
/>
</div>
<SubTitle
{...childProps}
 data-testid="Add.SubTitle:3"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyProfessionals/Item/Content/Add"
viewPath={`${viewPath}/SubTitle`}
 marginTop={50}
 text="Assign to locations"
/>
<div
 data-testid="Add.Vertical:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyProfessionals/Item/Content/Add"
 className={`views-block ${styles.Vertical1}`}
>
<ProviderLocations
 data-testid="Add.ProviderLocations"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyProfessionals/Item/Content/Add"
viewPath={`${viewPath}/ProviderLocations`}
/>
</div>
<SubTitle
{...childProps}
 data-testid="Add.SubTitle:4"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyProfessionals/Item/Content/Add"
viewPath={`${viewPath}/SubTitle`}
 marginTop={50}
 text="Select license type"
/>
<div
 data-testid="Add.Vertical:2"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyProfessionals/Item/Content/Add"
 className={`views-block ${styles.Vertical2}`}
>
<Licenses
 data-testid="Add.Licenses"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyProfessionals/Item/Content/Add"
viewPath={`${viewPath}/Licenses`}
/>
</div>
</React.Fragment>
)}
</ModalContent>
{children}
</React.Fragment>)
}